import { Box } from '@chakra-ui/layout';
import React from 'react';
import { Text, VStack } from '@chakra-ui/react';
import { ObjectText } from '../../types/ObjectTypes';
import { getTextByMarkType } from '../../services/Object/ObjectTextsDataService';
import styled from '@emotion/styled';

export interface ObjectTextsProps {
  textsData: Array<ObjectText>;
}

export const TextsContainer = styled.div`
  li {
    list-style-position: inside;
  }
`;

export const ObjectTexts = (props: ObjectTextsProps): JSX.Element => {
  const { textsData } = props;
  const longDescription = getTextByMarkType(textsData, 'M2');
  const holidayComplexDescription = getTextByMarkType(textsData, 'M8');
  const priceDescription = getTextByMarkType(textsData, 'M3');

  return (
    <Box
      p={4}
      borderRadius={{ sm: 0, md: 4, lg: 4, xl: 4 }}
      borderWidth={1}
      borderColor={'gray.300'}
      backgroundColor={'white'}
      w={'100%'}
      h={{ base: 'calc(100% - 56px)', md: 'unset' }}
      overflow={'auto'}>
      <VStack gridGap={4}>
        <Text w={'100%'} textAlign={'left'} fontSize={'xl'} textStyle={'category.primary'}>
          Beschreibung
        </Text>

        {longDescription.length > 0 && (
          <>
            <Text fontSize={'lg'} flex={1} width={'100%'} textStyle={'category.primary'}>
              Objekt
            </Text>
            <TextsContainer>
              <Text
                dangerouslySetInnerHTML={{
                  __html: longDescription,
                }}
              />
            </TextsContainer>
          </>
        )}

        {holidayComplexDescription.length > 0 && (
          <>
            <Text fontSize={'lg'} flex={1} width={'100%'} textStyle={'category.primary'}>
              Ferienanlage
            </Text>
            <TextsContainer>
              <Text
                dangerouslySetInnerHTML={{
                  __html: holidayComplexDescription,
                }}
              />
            </TextsContainer>
          </>
        )}

        {priceDescription.length > 0 && (
          <>
            <Text fontSize={'lg'} flex={1} width={'100%'} textStyle={'category.primary'}>
              Preisinformationen
            </Text>
            <TextsContainer>
              <Text
                dangerouslySetInnerHTML={{
                  __html: priceDescription,
                }}
              />
            </TextsContainer>
          </>
        )}
      </VStack>
    </Box>
  );
};
